import * as z from "zod";

export const getValidIndustryCategories = {
  name: "getValidIndustryCategories" as const,
  input: z.null(),
  output: z.object({ categoryIds: z.array(z.string()) }),
};
